// extracted by mini-css-extract-plugin
export default {"newsfeedCard":"y4-z"};